import Length from "./Length";
import Rectangle from "./Rectangle";
import Area from "./Area";
import AbstractShape from "./AbstractShape";

export default class Octagon extends AbstractShape {
	static NAME = "octagon";
	static SIDES = 8;

	constructor( side_length ) {
		super();

		this.side_length = side_length;
	}

	get_name() {
		return Octagon.NAME;
	}

	get_enclosing_rectangle() {
		const sqrt2 = Math.sqrt( 2 );
		const sideLength = this.get_side_length().in_mm();
		const width = sideLength * ( 1 + sqrt2 );
		return new Rectangle( new Length( width ), new Length( width ) );
	}

	get_area() {
		const sqrt2 = Math.sqrt( 2 );
		const area = 2 * ( 1 + sqrt2 ) * Math.pow( this.get_side_length().in_mm(), 2 );
		return new Area( area );
	}

	get_circumference() {
		return new Length( Octagon.SIDES * this.side_length.in_mm() );
	}

	get_side_length() {
		return this.side_length;
	}

	get_dimension_keys() {
		return [ "side_length" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			side_length: this.side_length
		};
	}

	static deserialize_primitives( primitives ) {
		return new Octagon( new Length( primitives.side_length ) );
	}
}
